import React from 'react';
import { TypedMemo } from '../../../common/types';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { SMLLink } from '../../components/SMLLink/SMLLink';
import { Music24Logo } from '../../components/Music24Logo';
import { Music24FullLogo } from '../../components/Music24FullLogo';
import { SidebarRailButton } from './SidebarRailButton';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole sidebar; each part uses its own slice of it */
import styles from '../../SMLSideBar.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SidebarBrandRowProps {
  isRail: boolean;
  onToggleRail: () => void;
  params?: Record<string, string>;
}

/**
 * design: navigation-v2 1a (nav2.css .brand2). The logo goes Home; the collapse button sits at
 * the right of the row. On the rail the row is the emblem alone, and the expand button moves to
 * the bottom (1f).
 */
const SidebarBrandRowComponent: React.FC<SidebarBrandRowProps> = ({ isRail, onToggleRail, params }) => {
  return (
    <div className={styles.brandRow}>
      <SMLLink to={SMLRoutes.home} params={params} className={styles.brand}>
        <span className={styles.brandMark}>
          <Music24Logo size={26} />
        </span>
        <span className={styles.brandText}>
          <Music24FullLogo size={22} className={styles.brandLogo} />
        </span>
      </SMLLink>
      {!isRail && <SidebarRailButton isRail={false} onToggleRail={onToggleRail} />}
    </div>
  );
};

export const SidebarBrandRow = TypedMemo(SidebarBrandRowComponent);
